/**
 * @file toast组件
 * @author chengyuan06@baidu.com
 * */

import './index.scss';

export default {
    hideTimeOut: null,

    /**
     * 初始化
     */
    init() {
        let toastNode = document.createElement('section');
        toastNode.innerHTML = '<span class="text"></span>'; // bca-disable-line
        toastNode.id = 'toast-waka';
        toastNode.setAttribute('class', 'toast');
        toastNode.style.display = 'none';
        document.body.appendChild(toastNode);
    },

    /**
     * 显示Toast
     *
     * @param {string} text 文本内容
     * @param {number} duration 持续时间(单位毫秒) 默认2s消失
     */
    show(text, duration = 2000) {
        if (this.hideTimeOut) {
            clearTimeout(this.hideTimeOut);
            this.hideTimeOut = null;
        }
        if (!text) {
            return;
        }
        let domToastWaka = document.getElementById('toast-waka');
        if (!domToastWaka) {
            return;
        }
        let domToastText = domToastWaka.querySelector('.text');
        domToastText.innerHTML = text || ''; // bca-disable-line
        domToastWaka.style.display = 'block';
        let that = this;
        this.hideTimeOut = setTimeout(function () {
            domToastWaka.style.display = 'none';
            that.hideTimeOut = null;
        }, duration);
    },

    /**
     * 隐藏 Toast
     */
    hide() {
        // 定时器存在
        if (this.hideTimeOut) {
            // 清空定时器
            clearTimeout(this.hideTimeOut);
            this.hideTimeOut = null;
        }
        let domToastWaka = document.getElementById('toast-waka');
        if (domToastWaka) {
            domToastWaka.style.display = 'none';
            document.body.removeChild(domToastWaka);
        }
    }
};

// export default Toast;